import { render, staticRenderFns } from "./publish-product-form.vue?vue&type=template&id=a69416fe&scoped=true&"
import script from "./publish-product-form.vue?vue&type=script&lang=js&"
export * from "./publish-product-form.vue?vue&type=script&lang=js&"
import style0 from "./publish-product-form.vue?vue&type=style&index=0&id=a69416fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69416fe",
  null
  
)

export default component.exports